import React from "react";
import PropTypes from "prop-types";

const RequiredFields = ({ className, color }) => (
  <svg
    className={className}
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.91812 3.4816C1.81477 3.5941 1.66898 3.66207 1.51477 3.64567C1.36055 3.67145 1.21148 3.61051 1.10227 3.4816L0.164742 2.54411C-0.0549141 2.34489 -0.0549141 1.98864 0.164742 1.76903C0.384375 1.54942 0.740625 1.54942 0.960234 1.76903L1.47844 2.28629L2.77031 0.852858C2.97656 0.621999 3.33281 0.603249 3.56484 0.811139C3.79453 1.01903 3.81328 1.37458 3.60469 1.60567L1.91812 3.4816ZM1.91812 7.2316C1.81477 7.3441 1.66898 7.41207 1.51477 7.39566C1.36055 7.42144 1.21148 7.36051 1.10227 7.2316L0.164742 6.2941C-0.0549141 6.09488 -0.0549141 5.73863 0.164742 5.51832C0.384375 5.30035 0.740625 5.30035 0.960234 5.51832L1.47844 6.03629L2.77031 4.60192C2.97656 4.37223 3.33281 4.35348 3.56484 4.56207C3.79453 4.76832 3.81328 5.12457 3.60469 5.3566L1.91812 7.2316ZM5.0625 2.72926C4.75078 2.72926 4.5 2.47848 4.5 2.16676C4.5 1.85622 4.75078 1.60426 5.0625 1.60426H11.4375C11.7492 1.60426 12 1.85622 12 2.16676C12 2.47848 11.7492 2.72926 11.4375 2.72926H5.0625ZM4.5 5.91676C4.5 5.60504 4.75078 5.35426 5.0625 5.35426H11.4375C11.7492 5.35426 12 5.60504 12 5.91676C12 6.22848 11.7492 6.47926 11.4375 6.47926H5.0625C4.75078 6.47926 4.5 6.22848 4.5 5.91676ZM3.75 9.66675C3.75 9.35503 4.00078 9.10425 4.3125 9.10425H11.4375C11.7492 9.10425 12 9.35503 12 9.66675C12 9.97847 11.7492 10.2293 11.4375 10.2293H4.3125C4.00078 10.2293 3.75 9.97847 3.75 9.66675ZM1.5 10.4168C1.08586 10.4168 0.75 10.0816 0.75 9.66675C0.75 9.25191 1.08586 8.91675 1.5 8.91675C1.91414 8.91675 2.25 9.25191 2.25 9.66675C2.25 10.0816 1.91414 10.4168 1.5 10.4168Z"
      fill={color}
    />
  </svg>
);

RequiredFields.defaultProps = {
  color: "#414042",
  className: "",
};

RequiredFields.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
};

export default RequiredFields;
